import { makeStyles } from '@material-ui/core/styles';

const useAccountMenuStyles = makeStyles((muiTheme) => ({
  sections: {
    padding: muiTheme.spacing(0, 0, 4),
  },
  logoutButton: {
    minWidth: 'auto !important',
    padding: muiTheme.spacing(1, 3),
    fontSize: '14px',
  },
}));

export default useAccountMenuStyles;
